import '../app.es6';
import angular from 'angular';

class HomeController {
  /* @ngInject */
  constructor ($scope, $location, $sessionStorage, LoginType) {
    this.location = $location;
    // TODO : 削除予定
    $scope.vm = $scope.vm || {};
    let user = $sessionStorage.user;
    let type = user.type;
    this.redirectByType(type);

    HomeController.$inject = ['$scope', '$location', '$sessionStorage', 'LoginType'];
  }

  redirectByType (userType) {
    switch (userType) {
      case 'companyAdmin':
        // TODO: companyAdmin
        // this.location.path('');
        break;
      case 'schoolAdmin':
        // TODO: schoolAdminの遷移先を指定
        // this.location.path('');
        break;
    }
  }
}

angular.module('myApp')
  .controller('HomeController', HomeController);



// WEBPACK FOOTER //
// ./app/controllers/home-controller.es6